<div class="nav-container">
  <div class="nav-bar">
    <!-- Logo Section -->
    <div class="logo-section">
      <a routerLink="/reports" class="nav-icon home active">
        <img class="aecom-logo" src="/assets/icons/aecom-logo.svg" alt="AECOM Logo" />
      </a>

      <div class="title-container">
        <p class="title">
          Environmental<br />
          Report Writer
        </p>
      </div>
    </div>

    <div class="right-section">
      <!-- Navigation Icons -->
      <div class="nav-icons">
        <div class="icon-group">
          <a routerLink="/reports" routerLinkActive="active" class="nav-icon home">
            <img src="/assets/icons/home_32.svg" alt="Home" />
          </a>
        </div>
      </div>

      <!-- Profile Section -->
      <div class="profile-section">
        <div class="profile-name-container" mat-icon-button aria-label="account-name">
        <span class="profile-initials">
            <div class="initial-center">{{ initials }}</div>
          </span>
          <span class="profile-name">{{ name }}</span>

          <button type="button" class="logout-button" (click)="handleLogout()">
            Logout
          </button> 
        </div>
      </div>
    </div>
  </div>
</div>